<app-typeFNS-simple-desc-marche2 [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[natureMarche]="fnSimpleAttribution.natureMarche"></app-typeFNS-simple-desc-marche2>